<template>
  <v-form ref="form">
    <div class="mb-3">
      Vui lòng chọn <span class="font-weight-medium">Học kỳ</span> và
      <span class="font-weight-medium">Lớp</span> cần xuất file điểm
    </div>
    <v-row>
      <v-col cols="4">
        <AutocompleteSemester
          v-model="semesterData"
          placeholder="Chọn học kỳ"
          label="Học kỳ"
          outlined
          dense
          hide-details
          required
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="4">
        <GradeClassStudentSelect
          disableGradeSelect
          disableStudentSelect
          :classCol="{
            sm: 12,
            md: 12
          }"
          @changed="onGradeClassStudentSelect"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSemester from '@/components/basic/input/AutocompleteSemester'
export default {
  components: { GradeClassStudentSelect, AutocompleteSemester },
  data: () => ({ semesterData: null, classData: null }),
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    onGradeClassStudentSelect(data) {
      this.classData = data.class
    },
    getData() {
      return {
        semester: this.semesterData,
        classData: this.classData
      }
    }
  }
}
</script>
